// import * as icons from "@material-ui/icons";
import { Button, Paper } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { compose } from "recompose";
import { Dispatch } from "redux";

import Search from "../../components/Search/Search";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "../../components/Table";
import TablePagination, {
  IPageEvent
} from "../../components/TablePagination/TablePagination";
import withDialog, { IDialogProps } from "../../hoc/Dialog";
import {
  IPaginationMetaResponse,
  IPaginationParams
} from "../../libs/quickjobs-api";
import {
  banJobRequest,
  cancelJobRequest,
  fetchJobsRequest,
  IJobBanRequestAction,
  IJobCancelRequestAction,
  IJobsFetchRequestAction
} from "../../store/actions/jobs";
import { IJob, IJobsState } from "../../store/types/job";
import { IUser } from "../../store/types/user";

import styles from "./styles";

class Jobs extends React.Component<IProps & IDialogProps, IState> {
  private static readonly DEFAULT_LIMIT = 10;

  public state = {
    detailId: null,
    term: null,
    limit: Jobs.DEFAULT_LIMIT
  };

  public componentDidMount() {
    this.props.fetchJobs({ limit: this.state.limit });
  }

  public handleTerm() {
    return (e: React.ChangeEvent<HTMLSelectElement>) => {
      const term = e.target.value as "one_time" | "long_term" | "full_time";
      if (term !== this.state.term) {
        this.setState({ term: term || null });
        this.props.fetchJobs({ limit: this.state.limit, term: term || null });
      }
    };
  }

  public handleBanJob(job: IJob) {
    return () => {
      this.props.openDialog(
        `${job.is_banned ? "Allow" : "Ban"} the Job ${job.id}`,
        "Are you sure you want to perform this action?",
        () => {
          this.props.banJob(job.id);
        }
      );
    };
  }

  public handleCancelJob(id: number) {
    return () => {
      this.props.openDialog(
        `Cancel the Job ${id}`,
        "Are you sure you want to cancel this offer?",
        () => {
          this.props.cancelJob(id);
        }
      );
    };
  }

  public handleSearch() {
    return (value: string) => {
      this.props.fetchJobs({ search: value, limit: this.state.limit });
    };
  }

  public handlePagination() {
    return (event: IPageEvent, limit: number) => {
      const { term } = this.state;
      this.setState({ limit });
      switch (event) {
        case IPageEvent.FIRST_PAGE:
          this.props.fetchJobs({ limit: limit, term });
          break;
        case IPageEvent.BACK:
          const firstJob: IJob = this.props.jobs[0];
          this.props.fetchJobs({
            since: firstJob.created_at,
            limit: limit,
            term
          });
          break;
        case IPageEvent.NEXT:
          const lastJob: IJob = this.props.jobs[this.props.jobs.length - 1];
          this.props.fetchJobs({
            until: lastJob.created_at,
            limit: limit,
            term
          });
          break;
      }
    };
  }

  public render() {
    const rows = this.props.jobs;
    const meta = this.props.meta;
    const isSales = this.props.loggedInUser.roles.includes("sales");

    return (
      <>
        <Paper className={this.props.classes.root}>
          <Select
            native={true}
            onChange={this.handleTerm()}
            value={this.state.term || ""}
          >
            <option value="">TERM</option>
            <option value="full_time">FT</option>
            <option value="long_term">DDB</option>
            <option value="one_time">JB</option>
          </Select>
          <br />
          <Search onSubmit={this.handleSearch()} />
          {rows.length ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell numeric={true}>ID</TableCell>
                  <TableCell>Author</TableCell>
                  <TableCell>Created</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Gender</TableCell>
                  <TableCell>Starts</TableCell>
                  <TableCell>Ends</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Platform</TableCell>
                  <TableCell>Salary</TableCell>
                  <TableCell numeric={true}>#reactions</TableCell>
                  <TableCell numeric={true}>#positive reactions</TableCell>
                  <TableCell numeric={true}>#calls</TableCell>
                  <TableCell numeric={true}>#accepted</TableCell>
                  <TableCell>Days to Expire</TableCell>
                  <TableCell>Term</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(r => {
                  return (
                    <TableRow
                      key={r.id}
                      hover={true}
                      style={{
                        backgroundColor:
                          (r.stats ? r.stats.accepted : 0) > 0
                            ? "green"
                            : undefined
                      }}
                    >
                      <TableCell numeric={true}>{r.id}</TableCell>
                      <TableCell>
                        <Link to={`/users/${r.author_id}`}>{r.author_id}</Link>
                      </TableCell>
                      <TableCell>
                        {new Date(r.created_at).toLocaleString("cs-CZ")}
                      </TableCell>
                      <TableCell>{r.description}</TableCell>
                      <TableCell>{r.gender}</TableCell>
                      <TableCell>{r.starts_at}</TableCell>
                      <TableCell>{r.ends_at}</TableCell>
                      <TableCell>
                        {r.place ? r.place.address : r.place_id}
                      </TableCell>
                      <TableCell>{r.platform}</TableCell>
                      <TableCell>
                        {r.salary}/{r.salary_type}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats ? r.stats.total : 0}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats
                          ? r.stats.applied +
                            r.stats.accepted +
                            r.stats.rejected
                          : 0}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats ? r.stats.calls : 0}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats ? r.stats.accepted : 0}
                      </TableCell>
                      <TableCell>
                        {moment(r.offer_expires_at).fromNow()}
                      </TableCell>
                      <TableCell numeric={true}>{r.term}</TableCell>
                      <TableCell>
                        <Link to={`/jobs/${r.id}`}>
                          <Button variant="contained" color="primary">
                            Detail
                          </Button>
                        </Link>
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={isSales || r.is_banned}
                          onClick={this.handleBanJob(r)}
                        >
                          {r.is_banned ? "Banned" : "Ban"}
                        </Button>
                        <Button
                          variant="contained"
                          disabled={isSales || r.status === "inactive"}
                          onClick={this.handleCancelJob(r.id)}
                        >
                          {r.status === "inactive" ? "Canceled" : "Cancel"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : null}
          {meta ? (
            <TablePagination
              hasPreviousPage={meta.has_previous}
              hasNextPage={meta.has_next}
              onChangePage={this.handlePagination()}
              defaultLimit={this.state.limit}
            />
          ) : null}
        </Paper>
      </>
    );
  }
}

interface IProps {
  loggedInUser: IUser;
  jobs: IJob[];
  meta: IPaginationMetaResponse | undefined;
  fetchJobs: (
    params?: {
      search?: string;
      term?: "one_time" | "long_term" | "full_time" | null;
    } & IPaginationParams
  ) => IJobsFetchRequestAction;
  banJob: (id: number) => IJobBanRequestAction;
  cancelJob: (id: number) => IJobCancelRequestAction;
  classes: { [name: string]: string };
}

interface IState {
  limit: number;
  term: "one_time" | "long_term" | "full_time" | null;
}

const mapStateToProps = (state: { jobs: IJobsState; auth: any }) => {
  return {
    loggedInUser: state.auth.user,
    jobs: state.jobs.jobs || [],
    meta: state.jobs.meta
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchJobs: (params?: { search?: string } & IPaginationParams) =>
      dispatch(fetchJobsRequest(params)),
    banJob: (id: number) => dispatch(banJobRequest(id)),
    cancelJob: (id: number) => dispatch(cancelJobRequest(id))
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withDialog
)(Jobs);



// WEBPACK FOOTER //
// ./src/screens/Jobs/Jobs.tsx